export interface AuthenticationResponse {
    clientId: number;
    emailOrPhoneNumber: string;
    userId: number;
    accessToken: any;
}
